import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExternalSignupPage = loadAsyncComponent(() => import('./Container'), 'page');
